const { expect } = require('chai');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Get tags and groups', () => {
  describe('get all tags', () => {
    const mock = loadRecordedMock('get_tags_preview.json');

    it(`should return ${mock.response.items.length} tags`, (done) => {
      migratortronApi.post(
        'get/tags',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.items)
            .to.be.an('array')
            .and.have.a.lengthOf(mock.response.items.length);

          expect(body.totalCount).to.equal(mock.response.items.length);
          done();
        }
      );
    });
  });

  describe('get all tags in a group', () => {
    const mock = loadRecordedMock(
      'get_tags_groupId=resourcePickersTagGroup_preview.json'
    );

    it(`should return ${mock.response.items.length} tags`, (done) => {
      migratortronApi.post(
        'get/tags?groupId=resourcePickersTagGroup',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.items)
            .to.be.an('array')
            .and.have.a.lengthOf(mock.response.items.length);

          expect(body.totalCount).to.equal(mock.response.items.length);
          done();
        }
      );
    });
  });

  describe('get a tag by its id', () => {
    const mock = loadRecordedMock(
      'get_tags_01346722-cafc-4c01-9688-a28ea6291fa5_preview.json'
    );

    it(`should return ${mock.response.items.length} tags`, (done) => {
      migratortronApi.post(
        'get/tags/01346722-cafc-4c01-9688-a28ea6291fa5',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.items)
            .to.be.an('array')
            .and.have.a.lengthOf(mock.response.items.length);

          expect(body.totalCount).to.equal(mock.response.items.length);
          done(error);
        }
      );
    });
  });

  describe('get a tag by its label', () => {
    const mock = loadRecordedMock(
      'get_tags_groupId=resourcePickersTagGroup_label=tag%201_preview.json'
    );

    it(`should return ${mock.response.items.length} tags`, (done) => {
      migratortronApi.post(
        'get/tags?groupId=resourcePickersTagGroup&label=tag 1',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.items)
            .to.be.an('array')
            .and.have.a.lengthOf(mock.response.items.length);

          expect(body.totalCount).to.equal(mock.response.items.length);
          done(error);
        }
      );
    });
  });

  describe('get all tag groups', () => {
    const mock = loadRecordedMock('get_taggroups_preview.json');

    beforeEach(() => {});

    it(`should return ${mock.response.items.length} tag groups`, (done) => {
      migratortronApi.post(
        'get/taggroups',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.items)
            .to.be.an('array')
            .and.have.a.lengthOf(mock.response.items.length);

          expect(body.totalCount).to.equal(mock.response.items.length);
          done();
        }
      );
    });
  });

  describe('get a tag group by its id', () => {
    const mock = loadRecordedMock(
      'get_taggroups_resourcePickersTagGroup_preview.json'
    );

    it(`should return ${mock.response.items.length} tag groups`, (done) => {
      migratortronApi.post(
        'get/taggroups/resourcePickersTagGroup',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.items)
            .to.be.an('array')
            .and.have.a.lengthOf(mock.response.items.length);

          expect(body.totalCount).to.equal(mock.response.items.length);
          done();
        }
      );
    });
  });

  describe('get tag groups with a query', () => {
    const mock = loadRecordedMock('get_taggroups_q=group_preview.json');

    it(`should return ${mock.response.items.length} tag groups`, (done) => {
      migratortronApi.post(
        'get/taggroups?q=group',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.items)
            .to.be.an('array')
            .and.have.a.lengthOf(mock.response.items.length);

          expect(body.totalCount).to.equal(mock.response.items.length);
          done();
        }
      );
    });
  });
});
